import styled from '@emotion/styled';

const PushFooterBelowInitialViewport = styled('div')({
  position: 'relative',
  height: '100vh',
  zIndex: -1,
});

export default PushFooterBelowInitialViewport;
